require('./stylesheet/style.scss');

angular.module('navigation.navbottom', [])
	.directive('navBottom', function() {
		return {
			template: require('./templates/index.html'),
			link: function($scope, iElm, iAttrs, controller) {
				$scope.currentYear = new Date().getFullYear();
			}
		}
	}
);

module.exports = 'navigation.navbottom';



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/footer/index.js
 ** module id = 246
 ** module chunks = 1
 **/